import script from "./CitizenOnboardingForm.vue?vue&type=script&lang=ts&setup=true"
export * from "./CitizenOnboardingForm.vue?vue&type=script&lang=ts&setup=true"

import "./CitizenOnboardingForm.vue?vue&type=style&index=0&id=e25d5694&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-e25d5694"]])

export default __exports__